import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterIteration } from '@/api/model/interfaces';

export default class RegisterIterationOdata extends OdataManager<RegisterIteration> {}
